export const ROUTE_HOME = '/';
export const ROUTE_AUTH = '/auth';
export const ROUTE_REMINDERS = '/reminders';
export const ROUTE_PROFILE = '/profile';
export const ROUTE_CREATE_REQUEST = '/create-request';
export const ROUTE_APPEALS = '/?type=appeals';
export const ROUTE_ONE_APPEAL = '/appeal';
export const ROUTE_ABOUT = '/about';
export const ROUTE_FAQ = '/faq';